import { render, staticRenderFns } from "./PartLanding.vue?vue&type=template&id=e20ecb44&scoped=true&"
import script from "./PartLanding.vue?vue&type=script&lang=js&"
export * from "./PartLanding.vue?vue&type=script&lang=js&"
import style0 from "./PartLanding.vue?vue&type=style&index=0&id=e20ecb44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20ecb44",
  null
  
)

export default component.exports